import { z } from 'zod';
import { requiredUuidString } from '../../zod-helpers/index.js';
import { rescheduleDeliveryReasonSchema } from './delivery-change-reason-schema.js';
/** The arguments beside Reschedule's `input`, which `scheduleSalesOrderDeliveryInputSchema` validates. */
export const rescheduleSalesOrderDeliveryArgsSchema = z.object({
    salesOrderId: requiredUuidString('Sales order is required.', 'Invalid sales order selection.'),
    reason: rescheduleDeliveryReasonSchema,
});
//# sourceMappingURL=reschedule-delivery-input.js.map